export default {
  common: {
    colon: ': ',
    cancel: '취소',
    confirm: '확인',
    back: '뒤로',
    noBooking: '예약 정보를 찾을 수 없습니다',
    placeholderNote: '화면 준비 중입니다 (디자인 대기)'
  },
  views: {
    trainList: {
      vehicleInfo: '차량 정보',
      ticketName: '신칸센 티켓',
      travelDate: '이용일: ',
      route: '출발 및 도착: ',
      ticketCount: '예약 수량: ',
      adult: '성인',
      child: '어린이',
      trainType: '차종',
      seatClass: '좌석 종류: ',
      preOrderNote:
        '*한 달 이상 앞선 예약의 경우 발권은 탑승일 한 달 전에 진행되며, 결과는 홈에서 확인하실 수 있습니다',
      selectStation: '역 선택',
      from: '출발',
      to: '도착',
      selectTrain: '열차 선택',
      select: '선택',
      book: '예약',
      seatAvailable: '여유 있음',
      seatLimited: '잔여 적음',
      soldOut: '매진',
      notOnSale: '판매 전',
      durationFormat: '{{hours}}시간 {{minutes}}분',
      noTrains: '해당 시간대에 열차가 없습니다'
    },
    seat: {
      title: '좌석 선택',
      ticketCount: '예약 수량',
      adult: '성인',
      preference: '좌석 선호',
      window: '창가 우선',
      aisle: '통로 우선',
      adjacent: '인접 좌석 우선',
      next: '다음'
    },
    confirm: {
      trainConfirm: '열차 확인',
      ticketName: '신칸센 티켓',
      route: '출발 및 도착: ',
      travelDate: '이용일: ',
      ticketCount: '예약 수량: ',
      trainType: '차종: ',
      seatClass: '좌석 종류: ',
      preference: '좌석 선호: ',
      confirmSelect: '선택 확인'
    },
    submitted: {
      title: '예약이 접수되었습니다',
      thanks: '예약해 주셔서 감사합니다. 홈에서 발권 결과를 확인해 주세요',
      thanksSub: '*탑승 한 달 전부터 발권이 시작됩니다. 잠시만 기다려 주세요',
      ticketName: '신칸센 티켓',
      route: '출발 및 도착: ',
      travelDate: '이용일: ',
      ticketCount: '예약 수량: ',
      trainType: '차종: ',
      seatClass: '좌석 종류: ',
      preference: '좌석 선호: ',
      backHome: '홈으로',
      noticeTitle: '주의사항',
      notice1:
        '매일 23:30~05:30(일본 시간) 시스템 점검 중에는 발권이 중단됩니다. 점검 종료 후 자동으로 발권되며 결과는 홈에서 확인할 수 있습니다.',
      notice2:
        '발권에 실패한 경우 홈의 티켓에 「잔여 적음」이 표시됩니다. 하단의 「티켓 예약」 버튼을 눌러 다시 진행해 주세요.'
    }
  }
};
